const URL_BASE=process.env.REACT_APP_API;

export const URL_BALANCE=`${URL_BASE}/financial/balance/hotmer`;
